import { useIsHydrated } from '@core/shared';
import { OptionsApi } from '@core/swagger-client';
import { ErrorMessage, Heading, Loader, Switch } from '@core/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const EmailPreferencesSection = () => {
    const { t } = useTranslation();
    const isHydrated = useIsHydrated();
    const queryClient = useQueryClient();

    const preferencesQuery = OptionsApi.emailPreferences.get();
    const { data: preferences, isLoading, error } = useQuery(preferencesQuery);

    const setPreferenceMutation = useMutation(OptionsApi.emailPreferences.set());

    const handleToggle = () => {
        const next = !(preferences?.unsubscribed ?? false);
        setPreferenceMutation.mutate(next, {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: preferencesQuery.queryKey });
            }
        });
    };

    return (
        <div className="relative bg-accent-lighter rounded-b-lg flex flex-col -mt-4 pt-8 px-4 md:px-8 pb-4 md:pb-6 z-1">
            <Heading variant="h2" classNames="pb-2">
                {t('EmailPreferences.PageHeading')}
            </Heading>
            <p className="mb-6">{t('EmailPreferences.Description')}</p>

            {error && <ErrorMessage apiError={error} classNames="mb-4" />}
            {setPreferenceMutation.error && <ErrorMessage apiError={setPreferenceMutation.error} classNames="mb-4" />}

            {isLoading || !preferences ? (
                <Loader />
            ) : (
                <Switch
                    data-testid="email-prefs-toggle"
                    id="email-prefs-toggle"
                    checked={preferences.unsubscribed}
                    disabled={!isHydrated || setPreferenceMutation.isPending}
                    onChange={handleToggle}
                    label={t('EmailPreferences.Toggle.Label')}
                />
            )}
        </div>
    );
};
